// extracted by mini-css-extract-plugin
export default {"popOverClick":"layouts_popOverClick__ZNxt8","popActive":"layouts_popActive__Qz3DO","collapseButton":"layouts_collapseButton__j93t8","logoutCard":"layouts_logoutCard__VjQNJ"};